/**
 * import and init third party
 * components/validators and other dependencies
 */

import Vue from 'vue'

// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.css'

// Vue.use(VueMaterial)
import 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    //Todo: Change the mockup key to colorbloqkey
    key: 'AIzaSyCuECgyGmMDm2me1DqZyEVHhQyQb1WPRuQ',
    libraries: 'places,drawing,visualization'
  }
});



// WEBPACK FOOTER //
// ./src/thirdParty/index.js